// :cow: Cosmose CONFIDENTIAL :iso:
export enum PlannerBasicDemoStepEnum {
  campaignListAddNewCampaign = 'japan-campaignListAddNewCampaign',
  campaignObjectiveSelectNewStoreOpening = 'japan-campaignObjectiveSelectNewStoreOpening',
  plannerStartSelectAudience = 'japan-plannerStartSelectAudience',
  audienceShowEstimates = 'japan-audienceShowEstimates',
  audienceReadSegmentDescriptions = 'japan-audienceReadSegmentDescriptions',
  audienceShowEstimatesChange = 'japan-audienceShowEstimatesChange',
  audienceSelectLocationCategories = 'japan-audienceSelectLocationCategories',
  audienceAnalyzeLocationCategories = 'japan-audienceAnalyzeLocationCategories',
  audienceClickEditBusinessCategories = 'japan-audienceClickEditLocationCategories',
  audienceExpandCategory = 'japan-audienceExpandCategory',
  audienceCloseLocationCategoriesDialog = 'japan-audienceCloseLocationCategoriesDialog',
  audienceExplainAddingLocationCategories = 'japan-audienceExplainAddingLocationCategories',
  audienceAskToSelectCity = 'japan-audienceAskToSelectCity',
  audienceShowTimespan = 'japan-audienceShowTimespan',
  audienceAskToClickContinue = 'japan-audienceAskToClickContinue',
  demographicsSelectGender = 'japan-demographicsSelectGender',
  demographicsAskToClickContinue = 'japan-demographicsAskToClickContinue',
  budgetSelectCampaignDuration = 'japan-budgetSelectCampaignDuration',
  budgetCalculationExplanation = 'japan-budgetCalculationExplanation',
  budgetAskToClickSummary = 'japan-budgetAskToClickSummary',
  mediaSearchPlatform = 'japan-mediaSearchPlatform',
  mediaExpandPlatform = 'japan-mediaExpandPlatform',
  mediaSelectFormat = 'japan-mediaSelectFormat',
  mediaAskToClickContinue = 'japan-mediaAskToClickContinue',
  summaryAskToClickSendForReview = 'japan-summaryAskToClickSendForReview',
  sentForReviewAskToClickBackToDashboard = 'japan-sentForReviewAskToClickBackToDashboard',
  campaignListExposeCampaign = 'japan-campaignListExposeCampaign',
}
